<app-modal [modalTitle]="modalTitle" [modalId]="modalId" (closeModal)="closeModalButtonTrigger()">
  <div modalBody>
    <form [formGroup]="createLinkForm" (ngSubmit)="onSubmit()">
      <div class="container">
        <div class="form-check form-switch check-style">
          <input [disabled]="true" class="form-check-input custom-disabled" type="checkbox" role="switch" id="datetimepicker" formControlName="isDatePickerSwitchChecked" />
          <label class="form-check-label text-size ml-3" for="datetimepicker">{{ 'SET_VALIDITY_DATE' | translate }}</label>
        </div>
        <div class="date-time mt-10" *ngIf="createLinkForm.get('isDatePickerSwitchChecked')?.value">
          <input
            type="datetime-local"
            [min]="commonService.getMinDate()"
            class="form-control input-style"
            (change)="onSelectDateTime($event)"
            formControlName="selectedDateTime"
            id="datePicker-switch"
            (input)="onInput($event)"
          />
        </div>
        <div class="form-check form-switch mt-10 check-style">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            value="createLinkForm.get('isPasswordSwitchChecked')?.value"
            [class.custom-disabled]="createLinkForm.get('isPasswordSwitchChecked')?.value && this.isEncrpyted"
            id="ask_password"
            formControlName="isPasswordSwitchChecked"
            id="password-switch"
          />
          <label class="form-check-label text-size ml-3" for="ask_password">{{ 'ASK_FOR_PASSWORD' | translate }}</label>
        </div>
        <div class="password mt-10" *ngIf="createLinkForm.get('isPasswordSwitchChecked')?.value">
          <div class="form-group mr-9">
            <input type="password" class="form-control input-style" id="password" [placeholder]="'PASSWORD' | translate" formControlName="password" />
            <div *ngIf="createLinkForm.get('password')?.hasError('required') && createLinkForm.get('password')?.touched">
              <div class="text-danger">{{ 'PASSWORD_CANNOT_BE_EMPTY' | translate }}</div>
            </div>
          </div>
          <div class="form-group">
            <input type="password" class="form-control input-style" id="password_again_" [placeholder]="'PASSWORD_AGAIN' | translate" formControlName="passwordAgain" />
            <div *ngIf="createLinkForm.get('passwordAgain')?.hasError('required') && createLinkForm.get('passwordAgain')?.touched">
              <div class="text-danger">{{ 'PASSWORD_REPETITION_CANNOT_BE_EMPTY' | translate }}</div>
            </div>
            <div *ngIf="createLinkForm.get('passwordAgain')?.hasError('mismatch') && createLinkForm.get('passwordAgain')?.touched">
              <div class="text-danger">{{ 'PASSWORDS_DO_NOT_MATCH' | translate }}</div>
            </div>
          </div>
        </div>
        <div class="form-check form-switch mt-10 check-style">
          <input class="form-check-input" type="checkbox" role="switch" id="ip" formControlName="isIpSwitchChecked" />
          <label class="form-check-label text-size ml-3" for="ip">{{ 'IP_RESTRICTION' | translate }}</label>
        </div>
        <div class="ip mt-10" *ngIf="createLinkForm.get('isIpSwitchChecked')?.value">
          <input type="text" class="form-control input-style" id="ipAddress" placeholder="--- .--- . --- . --- " formControlName="ipAddress" (input)="onInputValidation()" />
        </div>
        <div *ngIf="createLinkForm.get('ipAddress')?.errors">
          <div class="text-danger">{{ 'SUITABLE_IP_FORMAT' | translate }}</div>
        </div>
        <div class="form-check form-switch mt-10 check-style">
          <input class="form-check-input" type="checkbox" role="switch" id="download" formControlName="isDownloadSwitchChecked" />
          <label class="form-check-label text-size ml-3" for="download">{{ 'LIMIT_DOWNLOADS' | translate }}</label>
        </div>
        <div class="download mt-10" *ngIf="createLinkForm.get('isDownloadSwitchChecked')?.value">
          <input class="input-style mr-9 form-control" type="number" id="download_count" value="0" name="download_count" step="1" min="0" formControlName="downloadCount" />
          <span class="text-size">{{ 'DOWNLOAD_TIMES' | translate }} </span>
        </div>
        <div class="warning mt-10">
          <span *ngIf="!isEncrpyted">{{ 'ANYONE_CAN_ACCESS_UPDATED_LINK' | translate }} </span>
          <span *ngIf="isEncrpyted">{{ 'PASSWORD_PATTERN' | translate }} </span>
          <span class="ti ti-info-circle"></span>
        </div>
      </div>
    </form>
  </div>
  <div modalFooter>
    <button class="btn btn-primary btn-md btn-style" [hidden]="true" #btnCancelRef data-bs-dismiss="modal" id="cancel-btn">{{ 'CANCEL' | translate }}</button>
    <button class="btn btn-outline btn-primary btn-md btn-style mr-8" (click)="onCancel()" id="cancel-btn">{{ 'CANCEL' | translate }}</button>
    <button class="btn btn-primary btn-md btn-style" (click)="onSubmit()" [disabled]="createLinkForm.invalid" id="create-link-btn">{{ 'CREATE_LINK' | translate }}</button>
  </div>
</app-modal>
